import { useState } from 'react';
import { FCW } from 'types';
import { StaffNotesContext } from './StaffNotesContext';
import { STAFF_NOTES_MAX_LENGTH } from './staffNotes.constants';

export interface StaffNotes {
  staffNotes: string;
  setStaffNotes: React.Dispatch<React.SetStateAction<string>>;
  clearStaffNotes: () => void;
}

export const StaffNotesProvider: FCW = ({ children }) => {
  const [staffNotes, setStaffNotesState] = useState<string>('');

  const setStaffNotes: React.Dispatch<React.SetStateAction<string>> = (value) => {
    setStaffNotesState((prev) => {
      const nextValue = typeof value === 'function' ? value(prev) : value;
      return nextValue.slice(0, STAFF_NOTES_MAX_LENGTH);
    });
  };

  const clearStaffNotes = () => {
    setStaffNotes('');
  };

  return (
    <StaffNotesContext.Provider value={{ staffNotes, setStaffNotes, clearStaffNotes }}>
      {children}
    </StaffNotesContext.Provider>
  );
};
